fragment CorporateWorkgroupsFields on CorporateWorkgroup {
  __typename
  id
  _rowTimestamp
  _isUpdatable
  _isDeletable
  workgroupNumber
  name
  description
  businessUnit {
    id
    name
  }
  corporateChartOfAccount {
    id
    name
  }
  productionPhase {
    id
    statusType
  }
  isNewWorkgroupSelectable
  statusType {
    statusType
  }
}
